// Глобальная инициализация приложения. Здесь собран bootstrap-порядок,
// ранее находившийся в pages/admin.ts.
import { currentUser, currentUserRole, setCurrentUser, setCurrentUserRole } from "./state";
import { apiCall } from "./api";
import { showAppUI, showAuthUI } from "./pages/auth";
import { loadGroups, loadAllGroups } from "./pages/common";
import {
  loadColLabels,
  fetchKnownColumns,
  renderRenameEditor,
  loadAdminUsers,
  loadAdminAttrEditor,
  initTitleTemplateEditor,
  loadSearchConfig,
  loadMassColumnsEditor,
  loadSingleColumnsEditor,
  initExportEditor,
  initExportColumnsEditor,
  initMlExportEditor,
} from "./pages/admin";
import { loadAdminParserGroups } from "./pages/admin_parser_groups";
import { loadReferenceFiles, loadColumnSettings } from "./pages/reference";
import { TableEditor } from "./components/table-editor";
import {
  loadStrategyGroups,
  loadAdminOverrides,
  loadUserStrategies,
  loadDefaultStrategies,
} from "./pages/strategies";

// Side-effect imports: регистрируют обработчики и экспонируют функции в window.
import "./pages/mass";
import "./pages/single";

export async function bootstrapApp(): Promise<void> {
  new TableEditor();
  await loadColLabels();
  await loadStrategyGroups(); // для выпадающего списка стратегий
  await loadGroups();
  await loadAllGroups(); // для админки (все группы из БД)
  await loadColumnSettings();

  const token = localStorage.getItem("token");
  if (token) {
    const me = await apiCall("/api/me", "GET");
    if (me && me.username) {
      setCurrentUser(me.username);
      setCurrentUserRole(me.role || "user");
      document.getElementById("user-name").innerText = currentUser;
      document.getElementById("login-btn").style.display = "none";
      document.getElementById("profile-dropdown").style.display = "inline-block";
      document.getElementById("dropbtn-name").innerText = currentUser;
      document.getElementById("admin-cache-card").style.display =
        currentUserRole === "admin" ? "block" : "none";
      document.getElementById("nav-admin-btn").style.display =
        currentUserRole === "admin" ? "inline-block" : "none";
      showAppUI();
      await loadAdminOverrides();
      await loadUserStrategies();
    } else {
      localStorage.removeItem("token");
      showAuthUI();
      await loadAdminOverrides();
      await loadDefaultStrategies();
    }
  } else {
    showAuthUI();
    await loadAdminOverrides();
    await loadDefaultStrategies();
  }

  await loadReferenceFiles();

  // Навигация
  document.querySelectorAll<HTMLElement>(".nav-btn").forEach((btn) => {
    btn.onclick = async () => {
      document.querySelectorAll(".nav-btn").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const pageId = (btn as HTMLElement).dataset.page + "-page";
      document.querySelectorAll(".page").forEach((p) => p.classList.remove("active-page"));
      document.getElementById(pageId).classList.add("active-page");
      if ((btn as HTMLElement).dataset.page === "admin") {
        document.getElementById("admin-attr-card").style.display =
          currentUserRole === "admin" ? "block" : "none";
        document.getElementById("admin-title-template-card").style.display =
          currentUserRole === "admin" ? "block" : "none";
        loadAdminUsers();
        await fetchKnownColumns();
        renderRenameEditor("admin-mp-columns", "master_parser");
        renderRenameEditor("admin-sv-columns", "sveta_server");
        await loadAdminAttrEditor();
        await initTitleTemplateEditor();
        await loadSearchConfig();
        await loadMassColumnsEditor();
        await loadSingleColumnsEditor();
        await initExportEditor();
        await initExportColumnsEditor();
        await initMlExportEditor();
        await loadAdminParserGroups();
      }
    };
  });
}
